<template>
  <div :class="classes" v-loading="detailLoading">
    <pt-page-title title="积分发放详情"></pt-page-title>
    <pt-sub-title title="用户信息"></pt-sub-title>
    <pt-message-table-item label="积分发放流水号">{{pointsRewardsDetail.number}}</pt-message-table-item>
    <pt-message-table-item label="生命银行用户">{{pointsRewardsDetail.grantUser&&pointsRewardsDetail.grantUser.fullName}}
    </pt-message-table-item>
    <pt-message-table-item label="C端手机号">{{pointsRewardsDetail.grantUser&&pointsRewardsDetail.grantUser.mobile}}
    </pt-message-table-item>
    <pt-message-table-item label="平台注册时间">{{pointsRewardsDetail.grantUser&&pointsRewardsDetail.grantUser.register_date}}
    </pt-message-table-item>
    <pt-sub-title title="积分发放信息"></pt-sub-title>
    <pt-message-table-item label="发放时间">{{pointsRewardsDetail.created_date}}</pt-message-table-item>
    <pt-message-table-item label="发放人">{{pointsRewardsDetail.applyUser&&pointsRewardsDetail.applyUser.fullName}}
    </pt-message-table-item>
    <pt-message-table-item label="发放积分">{{pointsRewardsDetail.points}}</pt-message-table-item>
    <pt-sub-title title="积分审核信息"></pt-sub-title>
    <pt-message-table-item label="状态" :tdMaxWidth="maxWidthAll">{{pointsRewardsDetail.audit_status}}</pt-message-table-item>
    <div v-if="pointsRewardsDetail.status === 'COMPLETED'">
      <pt-message-table-item label="审核人">{{pointsRewardsDetail.auditUser&&pointsRewardsDetail.auditUser.fullName}}</pt-message-table-item>
      <pt-message-table-item label="审核时间">{{pointsRewardsDetail.approval_date}}</pt-message-table-item>
      <pt-message-table-item label="备注">{{pointsRewardsDetail.auditRemark}}</pt-message-table-item>
    </div>
    <div v-if="pointsRewardsDetail.status === 'REJECTED'">
      <pt-message-table-item label="审核人">{{pointsRewardsDetail.rejectUser&&pointsRewardsDetail.rejectUser.fullName}}</pt-message-table-item>
      <pt-message-table-item label="审核时间">{{pointsRewardsDetail.reject_date}}</pt-message-table-item>
      <pt-message-table-item label="驳回原因">{{pointsRewardsDetail.rejectReason}}</pt-message-table-item>
      <pt-message-table-item label="备注">{{pointsRewardsDetail.rejectRemark}}</pt-message-table-item>
    </div>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-points-reward-detail'
export default {
  name: 'pt-points-reward-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    pointsRewardsDetail: {
      type: Object
    },
    detailLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      maxWidthAll: '70'
    }
  }
}
</script>

<style module lang="less">
  @import "~less/var";
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */
</style>
